<template>
    <v-form
		class="restore-password-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
        <v-text-field
			class="pt-0 email-field"
			color="red"
			v-model="email"
			:error-messages="field_errors.email"
			:rules="rules.email"
			required
			placeholder="Email"
		/>
        <v-btn 
            class="restore-password-form__btn elevation-0"
            type="submit"
            :disabled="isLoading"
        >
            Restore
        </v-btn>
        <p
			class="text-center red--text mt-2"
			v-for="error in errorList"
			:key="error"
			style="width: 100%"
		>
			{{ error }}
		</p>
        <v-dialog v-model="isSubmitted" @click:outside="closeDialog">
            <div class="restore-password-form__dialog">
                <p class="restore-password-form__dialog-message">
                    We've sent you an email with a link to reset your password
                </p>
                <v-btn class="restore-password-form__dialog-submit elevation-0" @click="closeDialog">
                    <span class="px-4">
                        Got It!
                    </span>
                </v-btn>
                <v-btn class="restore-password-form__dialog-close elevation-0" @click="closeDialog">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
            </div>
        </v-dialog>
    </v-form>
</template>
<script>
import { ruleEmail, ruleRequired } from '@/utils/rules'
import Form from '@/mixins/Form'
import { mapGetters, mapActions } from 'vuex'
export default {
    mixins: [Form],
    data() {
        return {
            email: '',
            rules: {
                email: [
                    (v) => (ruleRequired(v) && ruleEmail(v.trim())) || (ruleRequired(v) ? 'Incorrect email' : 'Field is required.')
                ],
            },
            isSubmitted: false
        }
    },
    methods: {
        ...mapActions('auth', ['restoreUserPassword']),

        closeDialog() {
            this.isSubmitted = false
            this.$router.push({
                name: 'login'
            })
        },
        async submitForm() {
            const result = await this.restoreUserPassword({
                email: this.email
            })
            if (result) {
                this.isSubmitted = true
            }
        }
    },
    computed: {
        ...mapGetters('auth', ['isLoading', 'authErrors']),

        errorList() {
            if (this.authErrors.length <= 0) {
                return []
            }

            return [...new Set(this.authErrors)].filter(item => item)
        },
    }
}
</script>
<style lang="scss">
.restore-password-form {
    &__btn {
        width: 100% !important;
        font-size: 18px !important;
        font-weight: 700;
        line-height: 21.94px;
        border-radius: 8px;
        background-color: var(--button-main-background-color) !important;
        color: #fff !important;
        text-transform: capitalize;
        height: 50px !important;
    }

    &__dialog {
        background-color: #fff !important;
        max-width: 600px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 30px;
        border-radius: 10px;
        font-family: Montserrat, sans-serif;
        display: flex;
        flex-direction: column;
        align-items: center;

        &-message {
            font-size: 24px;
            color: var(--accent-color);
            font-weight: 700;
            line-height: 29.26px;
            text-align: center;
            margin-bottom: 40px !important;
        }

        &-submit {
            background-color: var(--button-main-background-color) !important;
            color: #fff !important;
            border-radius: 8px;
            font-size: 18px !important;
            font-weight: 700;
            line-height: 21.94px;
            text-transform: capitalize;
        }

        &-close {
            position: absolute;
            top: 14px;
            right: 14px;
            background-color: transparent !important;
            padding: 0 !important;
            min-width: auto !important;
            height: auto !important;

            i {
                color: var(--button-secondary-background-color) !important;
            }
        }
    }

    .email-field {
        input {
            font-size: 13px;
            font-weight: 500;
            max-height: 50px;
			padding-left: 10px;
        }
    
        .v-input__slot {
            border-bottom: 1px solid rgba(0, 0, 0, 0.6);
        }
    }
}
</style>